import * as Sentry from '@sentry/react';

import api from '../api/axios';
import authorizationHeader from '../api/token';

export const getLaminariaSectionDetail = async (laminariaId, sectionId) => {
  try {
    const headers = await authorizationHeader();
    const response = await api.get(`/laminaria/${laminariaId}/${sectionId}`, {
      headers,
    });
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getLegacyLaminaries = async () => {
  try {
    const headers = await authorizationHeader();
    const response = await api.get('/laminaria', { headers });
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getLegacyLaminarySections = async laminariaId => {
  try {
    const headers = await authorizationHeader();
    const response = await api.get(`/laminaria/${laminariaId}`, { headers });
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};
